(function ($) {

    function toggleDisabled($ele, add='') {
        if ($ele.length) {
            if(add === '') {
                let has = false;
                $ele.each(function(i){
                    if(this.hasAttribute('disabled'))
                    has = true;
                })

                has ? $ele.removeAttr('disabled') : $ele.attr('disabled', '');
            } else {
                !add ? $ele.removeAttr('disabled') : $ele.attr('disabled', '');
            }
        }
    }

    function onbaordingInit(){
        const section = $('.onboard');
        if(section.length) {
            let input = $('input#job');
            let checkbox = $('input#unsure');
            let btn = input.closest('.onboard__carsousel-item').find('.btn.next');

            // =====================
            // disable checkbox
            // =====================
            input.bind('change paste keyup', function() {
                if(this.value !== '') {
                    toggleDisabled(checkbox, true);
                    toggleDisabled(btn, false);
                } else {
                    toggleDisabled(checkbox, false);
                    toggleDisabled(btn, true);
                } 
            });

            // =====================
            // disable input
            // =====================
            checkbox.on('change',function(){
                toggleDisabled(input);
                toggleDisabled(btn);
            });

        }
    }

    onbaordingInit()

    // run function after barba enter
    if(window.barba !== undefined) {
        barba.hooks.enter((data) => {
            onbaordingInit();
        });
    }

})(jQuery);